import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteSlider, getSliders } from '../../../../../api/endpoints/cmsSite';
import type { Slider } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { SliderFormDialog } from '../SliderFormDialog';

/** Slider bir parent Site'a `site_Id` ile bağlı; bu sayfa yalnız `SiteDetailPage` içinde
 *  bir sekme olarak render edilir, `siteId` sabit prop olarak gelir. */
export default function SliderListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<Slider | null>(null);

  const query = useQuery({ queryKey: ['cms', 'sliders', siteId], queryFn: () => getSliders(siteId) });
  const rows: Slider[] = useMemo(() => query.data?.sliders ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteSlider(id),
    invalidateKeys: [['cms', 'sliders']],
    successMessage: 'Slider silindi.',
  });

  const columns: DataTableColumn<Slider>[] = [
    { id: 'img', header: 'Görsel Yolu', cell: (r) => r.imgPath ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="Slider"
      headerVariant="section"
      createLabel="Yeni Slider"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı slider bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <SliderFormDialog open={createOpen} slider={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <SliderFormDialog open={!!editing} slider={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="Slider'ı sil"
        description="Bu slider görselini silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
